
import DragDrop from '@/components/input/DragDrop.vue'
import IconClose from '@svg/IconClose.svg'
import IconInfoFilled from '@svg/IconInfoFilled.svg'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: {
    DragDrop,
    IconClose,
    IconInfoFilled,
  },
})
export default class UploadLibraryThumbnailDialog extends Vue {
  @Prop({ type: Boolean, required: true }) public value!: boolean
  @Prop({ type: String, required: true }) public dimensionInfo!: string
  @Prop({ type: Boolean, default: false }) public isUploading!: boolean

  public $refs!: Vue['$refs'] & {
    dragdrop: any
  }

  private isValid: boolean = false
  private isFileSelected: boolean = false
  private thumbnailFile: File | null = null
  private thumbnailPreview: any = ''

  private get isVisible(): boolean {
    return this.value
  }

  private set isVisible(val: boolean) {
    this.$emit('input', val)
  }

  private get customInstruction(): string {
    return `.png, no larger than ${this.dimensionInfo}<br />Design tip: Leave some space at the bottom of the thumbnail because our app shows the jig name overlaid.`
  }

  @Watch('value')
  private onValueChanged(newVal: boolean) {
    if (!newVal) {
      // Reset state when dialog closes
      this.resetState()
    }
  }

  private onFilesChanged(files: File[]) {
    // To display a thumbnail preview, we set a v-img src to the FileReader result.
    // Since it's a single file selection, we simply use the first file.
    if (files.length) {
      this.thumbnailFile = files[0]
    } else {
      this.thumbnailFile = null
    }

    if (FileReader && this.thumbnailFile && this.thumbnailFile.size) {
      this.isFileSelected = true
      this.isValid = true
      const fr = new FileReader()
      fr.onload = () => {
        this.thumbnailPreview = fr.result
      }
      fr.readAsDataURL(this.thumbnailFile)
    } else {
      this.isFileSelected = false
      this.thumbnailPreview = ''
    }
  }

  private onCancel() {
    this.isVisible = false
    this.$emit('cancel')
  }

  private onUpload() {
    if (this.thumbnailFile == null) return
    this.$emit('upload', this.thumbnailFile)
  }

  private resetState() {
    this.isValid = false
    this.isFileSelected = false
    this.thumbnailFile = null
    this.thumbnailPreview = ''

    // Clear files from DragDrop component
    if (this.$refs.dragdrop && this.$refs.dragdrop.clearFiles) {
      this.$refs.dragdrop.clearFiles()
    }
  }
}
